import {useClientLogin} from '../../hooks/useClientLogin';
import {AES, enc} from 'crypto-js';
import padZeroPadding from 'crypto-js/pad-zeropadding';

interface ECV1LinkProps {
    path: string;
    children: JSX.Element | JSX.Element[] | string;
    className?: string;
}

const encryptData = (data: Record<string, string>): string => {
    const key = enc.Hex.parse(process.env.REACT_APP_ECV1_SECRET ?? '');
    const iv = enc.Hex.parse(process.env.REACT_APP_ECV1_IV ?? '');

    return AES.encrypt(JSON.stringify(data), key, {
        iv: iv,
        padding: padZeroPadding,
    }).toString();
};

export  const getEncryptedURIV1 = (path: string, userLogin: string): string  => {

    const dataToEncrypt = {
        username: userLogin,
        datetime: `${new Date().toLocaleDateString('en')} ${new Date().toLocaleTimeString('en')}`,
        path: path.replace(/^\/+/, '')
    };

    const encryptedData = encryptData(dataToEncrypt);

    const ecv1Url = new URL(`${process.env.REACT_APP_ECV1_URL}/${path.replace(/^\/+/, '')}`);
    ecv1Url.searchParams.append('t', encryptedData);

    return ecv1Url.toString();
}

const ECV1Link = ({path, children, className}: ECV1LinkProps): JSX.Element => {
    const userLogin = useClientLogin();

    return (
        <a href={getEncryptedURIV1(path, userLogin)} className={className} target="_blank" rel="noreferrer">
            {children}
        </a>
    );
};

export default ECV1Link;
